import FeedStructure from "../../Constants/feedStructure"; // Adjust path as needed

export const fetchFeedData = async (userid) => {
  try {
    const response = await fetch(
      // `/api/mock/UserAccount/UserAccountPageMockData_${userid.toLowerCase()}.json`
      `/api/mock/MemberProfile/MemberProfileMockData_spadhy.json`
    );

    if (!response.ok) {
      throw new Error(`File not found for userid: ${userid}`);
    }

    const data = await response.json();

    const formattedData = {
      ...FeedStructure,
      userId: data.userId || "",
      nfriends: data.nfriends || 0,
      activeLevel: data.activeLevel || "",
      profileImage: data.profileImage || "",
      lastUpdatedOn: data.updated || data.lastUpdatedOn || "",
      rootuser: data.rootuser || data.userId || "",
      location: data.userLocation || data.location || "",
      createdOn: data.createdOn || "",
      lastActive: data.lastActive || "",
      status: data.status || "",
      feeds: (data.feeds || []).map((post) => ({
        postId: post.postId || "",
        postuuid: post.postuuid || "",
        descriptions: post.description || post.descriptions || "",
        timestamp: post.timestamp || "",
        location: post.location || "",
        nlikes: post.nlikes || 0,
        medias: (post.medias || []).map((media) => ({
          mediatype: media.mediatype || "",
          mediaurl: media.mediaurl || "",
          nlikes: media.nlikes || 0,
          comments: (media.comments || []).map((comment) => ({
            userId: comment.userId || "",
            comment: comment.comment || "",
            timestamp: comment.timestamp || "",
            location: comment.location || ""
          })),
          nshares: media.nshares || 0,
          nsuggests: media.nsuggests || 0
        })),
        comments: (post.comments || []).map((comment) => ({
          userId: comment.userId || "",
          comment: comment.comment || "",
          timestamp: comment.timestamp || "",
          location: comment.location || ""
        })),
        nshares: post.nshares || 0
      }))
    };

    return formattedData;
  } catch (error) {
    console.error(`Failed to fetch mock user post data for "${userid}":`, error);
    return null;
  }
};

export default fetchFeedData